import { render, staticRenderFns } from "./VPlaceholder.vue?vue&type=template&id=3c478bf2&"
import script from "./VPlaceholder.vue?vue&type=script&lang=js&"
export * from "./VPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports